import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarHiddenRightWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSidebarHiddenRightWide"><Path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM16 8V16H18V8H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarHiddenRightWide;
